// Global permissions
// .. permission to view man-hour information (man/hour)
const GLOBAL_MANHOUR_DSP_PERMISSIONS = 'AMSWEB_ACCESS_MOMO-DSP'
// .. permission to view price information
const GLOBAL_PRICE_DSP_PERMISSIONS = 'AMSWEB_ACCESS_DSP_PRICE'

// User's prefs
const USERPREFS_STORE_NAME = 'USERPREFS'
const USERPREFS_LANG = 'LANG'
const USERPREFS_THEME = 'THEME'
// .. Routine Maintenance global Params
const RMP_SAISIE_HORAIRE = 'saisieHoraire'

// Widget's properties names (used in STORE)
const PROP_POSITION = 'POSITION'
const PROP_SHOWN = 'SHOWN'
const PROP_EXPANDED = 'EXPANDED'
const PROP_WIDTH = 'WIDTH'
const PROP_HEIGHT = 'HEIGHT'
const PROP_PAGE_SIZE = 'PAGESIZE'
const PROP_TOLERANCE = 'TOLERANCE'

// Listing of all widgets' unique names (UNAMES) in the application

// .. page Avancement_BDV
const BDV_STORE_NAME = 'WORKPACKAGE'
// ... license access to the functionality
const BDV_LICACCESS = 'wpstatus'
const BDV_PERMISSIONS = 'AMSWEB_ACCESS_WPSTATUS'
const BDV_WDG_PLANNING_UNAME = 'WORKPACKAGE_PLANNING'
const BDV_WDG_PROGRESSION_UNAME = 'WORKPACKAGE_MAN'
const BDV_WDG_TYPE_TASK_UNAME = 'WORKPACKAGE_TYPE_TASK'
const BDV_WDG_WORKLOAD_UNAME = 'WORKPACKAGE_WORKLOAD'
const BDV_WDG_VISIT_SUMMARY_UNAME = 'WORKPACKAGE_VISIT_SUMMARY'
const BDV_WDG_LIST_TASKS_UNAME = 'WORKPACKAGE_LIST_TASKS'
const BDV_WDG_OE_UNAME = 'WORKPACKAGE_OE'

// .. page Tableau de Flotte
const TABFLOT_STORE_NAME = 'TABFLOT'
// ... license access to the functionality
const TABFLOT_LICACCESS = 'fleetpan'
const TABFLOT_PERMISSIONS = 'AMSWEB_ACCESS_FLEETPAN'
// ... aircraft configuration
const TABFLOT_AIRCRAFTS_CONFIGURATION_PERMISSIONS = 'AMSWEB_ACCESS_TCAV-DSP'
const TABFLOT_PPPR_PERMISSIONS = 'AMSWEB_ACCESS_FLEETPAN-PPPR'
const TABFLOT_WDG_AERONEFS_UNAME = 'TABFLOT_WDG_AERONEFS'
const TABFLOT_WDG_HIL_UNAME = 'TABFLOT_WDG_HIL'
const TABFLOT_WDG_PPPR_UNAME = 'TABFLOT_WDG_PPPR'
const TABFLOT_WDG_OE_UNAME = 'TABFLOT_WDG_OE'

// Page Orders to validate
const ORDERS_STORE_NAME = 'ORDERS'
// ... license access to the functionality
const ORDERS_LICACCESS = 'ordval'
const ORDERS_STCA_PERMISSIONS = 'AMSWEB_ACCESS_STCA_VAL_CDE'
const ORDERS_STCA_AOG_PERMISSIONS = 'AMSWEB_ACCESS_STCA_VAL_CDE_AOG'
const ORDERS_STCL_PERMISSIONS = 'AMSWEB_ACCESS_STCL_VAL_CDE'
const ORDERS_STCR_PERMISSIONS = 'AMSWEB_ACCESS_STCR_VAL_CDE'
const ORDERS_STCS_PERMISSIONS = 'AMSWEB_ACCESS_STCS_VAL_CDE'
// .. levels
const ORDERS_STCA_LEVELS = 'STCA_VAL_CDE'
const ORDERS_STCA_AOG_LEVELS = 'STCA_VAL_CDE_AOG'
const ORDERS_STCL_LEVELS = 'STCL_VAL_CDE'
const ORDERS_STCR_LEVELS = 'STCR_VAL_CDE'
const ORDERS_STCS_LEVELS = 'STCS_VAL_CDE'
// ... component table of page Orders
const ORDERS_TABLE_UNAME = 'ORDERS'
// .. component Order to validate of page Orders
const ORDER_FORM_UNAME = 'ORDER'

// Page TechLogInput
const CRM_STORE_NAME = 'CRM'
// ... license access to the functionality
const CRM_LICACCESS = 'tlinput'
// .. Routine Maintenance Params for CRM/techLog
// .... User can manage fuel-lines (add/remove)
const RMP_FUEL_UNIT = 'fuelUnit'
// .... User can view and manage fuel totals
const RMP_CRM_DISPLAY_TOTALS = 'dspTot'
const RMP_CRM_INPUT_BB = 'saisieBB'
const RMP_CRM_INPUT_DEP_ARR = 'saisieDepArr'
// .... Code tâche obligatoire
const RMP_WO_MANDATORY_WORKCODE = 'mandatoryWorkCode'
// .. Permissions
const CRM_DISPLAY_PERMISSIONS = 'AMSWEB_ACCESS_MACRM-DSP'
const CRM_CREATE_PERMISSIONS = 'AMSWEB_ACCESS_MACRM-CRT'
const CRM_UPDATE_PERMISSIONS = 'AMSWEB_ACCESS_MACRM-UPD'
// ... component field auto-complete (aircrafts) of page TechLogInput
const CRM_AIRCRAFT_SELECTION_UNAME = 'TECHLOGS_FOR_AIRCRAFT'
// ... component table of page TechLogInput
const CRM_TABLE_UNAME = 'TECHLOGS'
// .. component Form for TechLog
const CRM_FORM_UNAME = 'TECHLOG'
// .. component name for a new empty TechLog
const CRM_NEW_UNAME = 'TECHLOG_NEW'

// Page Work-Order
const WORKORDER_STORE_NAME = 'WORKORDER'
// .. Permissions
const WORKORDER_DISPLAY_PERMISSIONS = 'AMSWEB_ACCESS_MAOE-DSP'
const WORKORDER_CREATE_PERMISSIONS = 'AMSWEB_ACCESS_MAOE-CRT'
// Permission to update any WO of type other than SB
const WORKORDER_UPDATE_PERMISSIONS = 'AMSWEB_ACCESS_MAOE-UPD'
// Permission to update WO of type SB
const WORKORDER_UPDATE_OE_SB_PERMISSIONS = 'AMSWEB_ACCESS_MAOE_-_UPD_OE/SB'
// Permission to update requested work (TD) and performed work (TE) of a WO
const WORKORDER_UPDATE_TD = 'AMSWEB_ACCESS_MAOE_-_UPD_TD'
const WORKORDER_UPDATE_TE = 'AMSWEB_ACCESS_MAOE_-_UPD_TE'

// ... component details of Work-Order
const WORKORDER_DETAILS_UNAME = 'WO_DETAILS'
// ... component required tools of Work-Order
const WORKORDER_REQUIRED_TOOLS_UNAME = 'WO_REQUIRED_TOOLS'
// ... component used tools of Work-Order
const WORKORDER_USED_TOOLS_UNAME = 'WO_USED_TOOLS'
// ... component man-hour of Work-Order
const WORKORDER_MANHOUR_UNAME = 'WO_MANHOUR'
// ... component linked documents of Work-Order
const WORKORDER_LINKED_DOCS_UNAME = 'WO_LINKED_DOCS'
// ... component installation/removal of Work_Order
const WORKORDER_INSTALLATION_REMOVAL_UNAME = 'WO_INSTALLATION_REMOVAL'

// Page Consultation des stocks
// ... license access to the functionality
const STOCKS_LICACCESS = 'stocks'
const STOCKS_DSP_PERMISSIONS = 'AMSWEB_ACCESS_STST-DSP'
const STOCKS_INTERCHANGEABLE_UNAME = 'STOCKS_INTERCHANGEABLE'
const STOCKS_STORE_NAME = 'STOCKS'

const ComponentsUNames = {
  USERPREFS_STORE_NAME,
  USERPREFS_LANG,
  USERPREFS_THEME,
  RMP_SAISIE_HORAIRE,
  PROP_POSITION,
  PROP_SHOWN,
  PROP_EXPANDED,
  PROP_WIDTH,
  PROP_HEIGHT,
  PROP_PAGE_SIZE,
  PROP_TOLERANCE,
  GLOBAL_MANHOUR_DSP_PERMISSIONS,
  GLOBAL_PRICE_DSP_PERMISSIONS,
  BDV_STORE_NAME,
  BDV_LICACCESS,
  BDV_PERMISSIONS,
  BDV_WDG_PLANNING_UNAME,
  BDV_WDG_PROGRESSION_UNAME,
  BDV_WDG_TYPE_TASK_UNAME,
  BDV_WDG_WORKLOAD_UNAME,
  BDV_WDG_VISIT_SUMMARY_UNAME,
  BDV_WDG_LIST_TASKS_UNAME,
  BDV_WDG_OE_UNAME,
  TABFLOT_STORE_NAME,
  TABFLOT_LICACCESS,
  TABFLOT_PERMISSIONS,
  TABFLOT_AIRCRAFTS_CONFIGURATION_PERMISSIONS,
  TABFLOT_PPPR_PERMISSIONS,
  TABFLOT_WDG_AERONEFS_UNAME,
  TABFLOT_WDG_HIL_UNAME,
  TABFLOT_WDG_PPPR_UNAME,
  TABFLOT_WDG_OE_UNAME,
  ORDERS_STORE_NAME,
  ORDERS_LICACCESS,
  ORDERS_TABLE_UNAME,
  ORDERS_STCA_PERMISSIONS,
  ORDERS_STCA_AOG_PERMISSIONS,
  ORDERS_STCL_PERMISSIONS,
  ORDERS_STCR_PERMISSIONS,
  ORDERS_STCS_PERMISSIONS,
  ORDERS_STCA_LEVELS,
  ORDERS_STCA_AOG_LEVELS,
  ORDERS_STCL_LEVELS,
  ORDERS_STCR_LEVELS,
  ORDERS_STCS_LEVELS,
  ORDER_FORM_UNAME,
  CRM_STORE_NAME,
  CRM_LICACCESS,
  RMP_FUEL_UNIT,
  RMP_CRM_DISPLAY_TOTALS,
  RMP_CRM_INPUT_BB,
  RMP_CRM_INPUT_DEP_ARR,
  RMP_WO_MANDATORY_WORKCODE,
  CRM_DISPLAY_PERMISSIONS,
  CRM_CREATE_PERMISSIONS,
  CRM_UPDATE_PERMISSIONS,
  CRM_AIRCRAFT_SELECTION_UNAME,
  CRM_TABLE_UNAME,
  CRM_FORM_UNAME,
  CRM_NEW_UNAME,
  WORKORDER_STORE_NAME,
  WORKORDER_DISPLAY_PERMISSIONS,
  WORKORDER_CREATE_PERMISSIONS,
  WORKORDER_UPDATE_PERMISSIONS,
  WORKORDER_UPDATE_OE_SB_PERMISSIONS,
  WORKORDER_UPDATE_TD,
  WORKORDER_UPDATE_TE,
  WORKORDER_DETAILS_UNAME,
  WORKORDER_REQUIRED_TOOLS_UNAME,
  WORKORDER_USED_TOOLS_UNAME,
  WORKORDER_MANHOUR_UNAME,
  WORKORDER_LINKED_DOCS_UNAME,
  WORKORDER_INSTALLATION_REMOVAL_UNAME,
  STOCKS_LICACCESS,
  STOCKS_DSP_PERMISSIONS,
  STOCKS_INTERCHANGEABLE_UNAME,
  STOCKS_STORE_NAME,
}

export default ComponentsUNames
